// eslint-disable-next-line import/no-unresolved, import/extensions
import React, { Component } from 'react'
import PropTypes from 'prop-types'

const getNodeWidth = node => {
  const nodeStyles = window.getComputedStyle(node)
  const width = parseFloat(nodeStyles.width)
  const borderLeftWidth = parseFloat(nodeStyles.borderLeftWidth)
  const borderRightWidth = parseFloat(nodeStyles.borderRightWidth)
  const paddingLeft = parseFloat(nodeStyles.paddingLeft)
  const paddingRight = parseFloat(nodeStyles.paddingRight)
  return width - borderRightWidth - borderLeftWidth - paddingLeft - paddingRight
}

const getNodeHeight = node => {
  const nodeStyles = window.getComputedStyle(node)
  return parseFloat(nodeStyles.height)
}

const styles = ({ wrapText, textAlign, fitText }) => ({
  main: {
    display: 'inline-block',
    whiteSpace: wrapText ? 'normal' : 'nowrap',
    overflow: 'hidden',
    transformOrigin: '0 0 0',
    textOverflow: 'inherit',
    ...!fitText && { width: '100%' },
    textAlign
  },
  animate: {
    msTransition: '-ms-transform 400ms',
    WebkitTransition: '-webkit-transform 400ms',
    OTransition: '-o-transform 400ms',
    MozTransition: '-moz-transform 400ms',
    transition: 'transform 400ms'
  }
})

export default class ReactDynamicFont extends Component {
  static propTypes = {
    content: PropTypes.object,
    smooth: PropTypes.bool,
    scalable: PropTypes.bool
  }

  static defaultProps = {
    content: '',
    smooth: false,
    scalable: true
  }

  constructor (props) {
    super(props)
    this.state = {
      scale: 1
    }
  }

  componentDidMount () {
    if (this.props.content && this.props.content.length) {
      this.fixWidth()
    }
  }

  componentDidUpdate (prevProps) {
    if (prevProps.content !== this.props.content) {
      this.fixWidth()
    }
  }

  getMaxWidth = () => getNodeWidth(this.node.parentNode)

  getCurrentWidth = () => getNodeWidth(this.node)

  fixWidth = () => {
    const maxWidth = this.getMaxWidth()
    const currentWidth = this.getCurrentWidth()
    const currentHeight = getNodeHeight(this.node)
    const maxHeight = getNodeHeight(this.node.parentNode)
    const scaleW = maxWidth / currentWidth
    const scaleH = maxHeight / currentHeight
    let scale = 1
    if (scaleH < scaleW) {
      scale = scaleH
    } else {
      scale = scaleW
    }
    this.setState({ scale })
  }

  render () {
    let scaleStyle
    if (this.state.scale === 1) {
      scaleStyle = undefined
    } else {
      const transformValue = `scale(${this.state.scale}, ${this.state.scale})`
      scaleStyle = {
        msTransform: transformValue,
        WebkitTransform: transformValue,
        OTransform: transformValue,
        MozTransform: transformValue,
        transform: transformValue
      }
    }
    let transformOrigin = '0 0'
    if (this.props.textAlign === 'center') transformOrigin = '50% 0'
    if (this.props.textAlign === 'right') transformOrigin = '100% 0'

    const finalStyle = Object.assign(
      {},
      styles(this.props).main,
      { transformOrigin },
      this.props.smooth ? styles.animate : undefined,
      this.props.scalable ? scaleStyle : null
    )
    return (
      <span
        style={finalStyle}
        ref={(span) => { this.node = span }}
        dangerouslySetInnerHTML={{ __html: this.props.content }}
      />
    )
  }
}
